/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    new WOW().init()

    let spImgList = [
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-p1.png',
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-p2.png',
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-p1-2.png',
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-p2-2.png',
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-p1-3.png',
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-p2-3.png',

        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-a1.png',
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-a2.png',
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-a3.png',
        'https://cdn.shopify.com/s/files/1/0582/9948/2167/files/20251025-a4.png',
    ]

    new Swiper('.sp-swiper-fade', {
        spaceBetween: 10,
        effect: 'fade',
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    })
    new Swiper('.sp-swiper-fade2', {
        spaceBetween: 10,
        effect: 'fade',
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    })

    new Swiper('.sp-swiper-fade1', {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
        on: {
            slideChange: function (e) {
                e.slides.find('.sp-text').each(function () {
                    this.style.animation = 'none'
                })
                const spText = e.slides.eq(e.activeIndex).find('.sp-text')[0]
                if (spText) {
                    spText.style.animation = 'none'

                    spText.style.animation = `swiper-up-fade 0.5s ease forwards`
                }
            },
        },
    })

    new Swiper('.sp-swiper-scroll1', {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 0,
        },
        slidesPerView: 'auto',
        speed: 4000,
        loop: true,
        spaceBetween: 20,
    })

    jQuery('.sp-scroll').slide({
        mainCell: '.nav-imgs',
        autoPlay: true,
        effect: 'leftMarquee',
        interTime: 12,
        vis: 1,
        scroll: 1,
    })
    jQuery('.sp-scroll2').slide({
        mainCell: '.nav-imgs',
        autoPlay: true,
        effect: 'leftMarquee',
        interTime: 12,
        vis: 1,
        scroll: 1,
    })
    new Swiper('.sp-swiper1', {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 0,
        loop: true,
    })
    // new Swiper(".sp-swiper2", {
    //   autoplay: true,
    //   autoplay: {
    //     disableOnInteraction: false,
    //   },
    //   spaceBetween: 20,
    //   loop: true,
    // });
    // new Swiper(".sp-swiper22", {
    //   autoplay: true,
    //   autoplay: {
    //     disableOnInteraction: false,
    //   },

    //   spaceBetween: 20,

    //   loop: true,
    // });

    $('.product-box .sp-opt').click(function () {
        $(this).siblings().removeClass('active')
        $(this).addClass('active')
        let _index = $(this).index()

        $(this)
            .parents('.product-box')
            .find('.sp-p-img')
            .eq([_index])
            .show()
            .siblings('.sp-p-img')
            .hide()
    })
    // $('.sp-btn-style').click(function () {
    //     let num = $(this).prev().find('#calcNumber').val() || 1
    //     let id = $(this).data('id')

    //     window.location.href = '/cart/' + id + ':' + num

    //     //  $.post('/api/checkout/order', {
    //     //     line_items: [{
    //     //         quantity: num, // 数量
    //     //         variant_id: id, // 子商品id
    //     //         note: '', // 备注
    //     //     }],
    //     //     refer_info: { source: 'buy_now' }
    //     //     }, function (ret) {
    //     //     if (ret.state === 'success') {
    //     //         return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
    //     //     } else {
    //     //         $.toast.show({
    //     //         content:
    //     //             {
    //     //             '30003': "Some items have been removed, please re-order",
    //     //             'line_items_variant_withdraw': "Some items have been sold out, please re-order",
    //     //             'line_items_variant_sold_out': "Some items are not in stock, please re-order"
    //     //             }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
    //     //         });
    //     //     }
    //     //     });
    // })

    $(document).on('click', '.sp-btn-style', function (e) {
    var $box = $(this).closest('.product-box');
    var variantId = $box.find('.sp-opt-group .active').data('id');
    var quantity = $box.find('input[type="number"]').val() || 1;
    if (variantId) {
        window.location.href = '/cart/' + variantId + ':' + quantity;
    } 
});
    function mainRender() {
        $(function () {
            $('#root').css('zoom', 'normal')
            if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
            } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
            }

            window.addEventListener(
                'resize',
                (function () {
                    var timer
                    return function () {
                        if (timer) clearTimeout(timer)
                        timer = setTimeout(function () {
                            $('#root').css('zoom', 'normal')
                            if (document.body.clientWidth <= 1060) {
                                let scale = document.body.clientWidth / 1080
                                $('#root').css('zoom', scale)
                            } else {
                                const scale = document.body.clientWidth / 1920
                                $('#root').css('zoom', scale)
                            }
                        }, 100)
                    }
                })()
            )
        })

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
            const config = {
                rootMargin: '0px 0px 1300px 0px',
                threshold: 0,
            }

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target
                        const dataSrc = image.getAttribute('data-src')
                        image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                        lazyLoadObserver.unobserve(image) // 停止观察该图片
                    }
                })
            },
                config)

            images.forEach(function (image) {
                lazyLoadObserver.observe(image) // 开始观察每个图片
            })
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach(subArray => {
                    subArray.forEach(url => {
                        const img = new Image()
                        img.src = url
                    })
                })
            } else {
                // 处理一维数组
                imageArray.forEach(url => {
                    const img = new Image()
                    img.src = url
                })
            }
        }

        lazyLoadImages()

        preloadImages(spImgList)

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为
                // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop
                let sptop = document.body.clientWidth <= 1080 ? 72 : 34

                window.scroll({
                    top:
                        offsetTop * $('div#root').css('zoom') -
                        sptop * $('div#root').css('zoom'),
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                })
            })
        })

        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        var isAndroid = /android/i.test(userAgent)
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

        if (isAndroid) {
            console.log('Android')
        } else if (isIOS) {
            console.log('iOS')
        } else if (isPC) {
            console.log('PC')
        } else {
            $('.sp_system').css('letter-spacing', '-4px')
        }
    }

    mainRender()

    let sp_price1 = window.product[0].price / 100
    let sp_price2 = window.product[0].compare_at_price / 100

    function calcTotal(price, num) {
        let result = Number(price) * Number(num)
        return result.toFixed(2).replace(".",',')
    }
    $('.sp-mobile .sp-reduce').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) - 1
        if (num > 0) {
            input.value = num
        }
        $('#sp_price1').html(calcTotal(sp_price1, input.value))
        $('#sp_price2').html(calcTotal(sp_price2, input.value))
    })
    $('.sp-mobile .sp-add').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) + 1
        input.value = num
        $('#sp_price1').html(calcTotal(sp_price1, input.value))
        $('#sp_price2').html(calcTotal(sp_price2, input.value))
    })

    $('.sp-pc .sp-reduce').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) - 1
        if (num > 0) {
            input.value = num
        }
        $('#sp_price3').html(calcTotal(sp_price1, input.value))
        $('#sp_price4').html(calcTotal(sp_price2, input.value))
    })
    $('.sp-pc .sp-add').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) + 1
        input.value = num
        $('#sp_price3').html(calcTotal(sp_price1, input.value))
        $('#sp_price4').html(calcTotal(sp_price2, input.value))
    })
    $('.sp-pc .product-box').click(function () {
        $(this).addClass('sp-active').siblings().removeClass('sp-active')
    })

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll('span')
        const paragraph = gradually.querySelector('.sp-sub-title')

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 给每个 span 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`
                            span.style.animationDelay = `${index * 0.1}s`

                            const i = span.querySelector('i')
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`
                                i.style.animationDelay = `${index * 0.1}s`
                            }
                        })

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
                            paragraph.style.animationDelay = `${totalDelay}s`
                        }

                        observer.unobserve(gradually)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observer.observe(gradually)
    }

    // 产品切换
    $('.sp-mobile .sp-product-btn').click(function () {
        $(this).addClass('active').siblings().removeClass('active')
        let _index = $(this).index()
        $('.sp-mobile .sp-product-inner')
            .eq(_index)
            .addClass('active')
            .siblings()
            .removeClass('active')
    })
    // 产品切换-pc
    $('.sp-pc .sp-product-btn').click(function () {
        $(this).addClass('active').siblings().removeClass('active')
        let _index = $(this).index()
        $('.sp-pc .sp-product-inner')
            .eq(_index)
            .addClass('active')
            .siblings()
            .removeClass('active')
    })

    // // 点击按钮
    // $(".sp-video-btn").click(function () {
    //   $(".sp-mask").css("display", "flex");
    // });
    // // 关闭弹窗按钮

    // $(".sp-mask").click(function (e) {
    //   if ($(e.target).closest(".sp-mask video").length > 0) {
    //   } else {
    //     $(".sp-mask").hide();
    //   }
    // });

    // 菜单
    $('.sp-menu-btn').click(function (e) {
        $('.sp-menu-mask').show()
    })

    $('.sp-menu-mask').click(function (e) {
        // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
        // } else {
        $('.sp-menu-mask').hide()
        // }
    })

    // 滚动隐藏顶部
    if (
        $(window).scrollTop() >
        $('.sp-header').height() * $('div#root').css('zoom')
    ) {
        $('.header-bottom').addClass('sp-fixed')
    } else {
        $('.header-bottom').removeClass('sp-fixed')
    }

    $(window).scroll(function () {
        if (
            $(window).scrollTop() >
            $('.sp-header').height() * $('div#root').css('zoom')
        ) {
            $('.header-bottom').addClass('sp-fixed')
        } else {
            $('.header-bottom').removeClass('sp-fixed')
        }
    })

    // 问答
    $('.q-row').click(function () {
        $(this).parent().toggleClass('sp-show')
    })

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName('sp-fade-box')
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll('.sp-ani')

        const observerAni = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`
                        })

                        observerAni.unobserve(gradually2)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually2)
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

        const observerAni = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`
                            span.style.animationDelay = `${index * 0.3 + 1}s`
                        })

                        observerAni.unobserve(gradually3)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually3)
    }
})
